import produce from 'immer';
import { combineReducers } from 'redux';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { ActivityAction, ActivityActionType } from '../../actions/activityActions';
import { UpdateProcessActivityOrderAction, ProcessActionType } from '../../actions/processActions';

interface ActivityState {
  byId: Record<string, RcInstanceDTO.Activity>;
  allIds: string[];
}

export const initialState: ActivityState = {
  byId: {},
  allIds: [],
};

const byId = (
  state = initialState.byId,
  action: ActivityAction | UpdateProcessActivityOrderAction,
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityActionType.GET_ACTIVITIES:
        return {};
      case ActivityActionType.GET_WORKSPACE_ACTIVITIES_OK:
      case ActivityActionType.GET_ACTIVITIES_OK: {
        action.data.forEach((activity) => {
          draft[activity.id] = activity;
        });

        break;
      }
      case ProcessActionType.UPDATE_PROCESS_ACTIVITY_ORDER_OK: {
        action.data.forEach((activity) => {
          draft[activity.id] = activity;
        });

        break;
      }
      case ActivityActionType.GET_ACTIVITY_OK: {
        draft[action.activityId] = action.data;
        break;
      }
      case ActivityActionType.EDIT_ACTIVITY_OK: {
        draft[action.activityId] = action.data;
        break;
      }
      case ActivityActionType.DELETE_ACTIVITY_OK: {
        action.data.forEach((activity) => {
          draft[activity.id] = activity;
        });

        break;
      }
      case ActivityActionType.CREATE_ACTIVITY_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      default:
        return state;
    }
  });

const allIds = (
  state = initialState.allIds,
  action: ActivityAction | UpdateProcessActivityOrderAction,
) => {
  switch (action.type) {
    case ActivityActionType.GET_ACTIVITIES:
      return [];
    case ActivityActionType.GET_ACTIVITIES_OK:
      return action.data.map((activity) => activity.id);
    case ProcessActionType.UPDATE_PROCESS_ACTIVITY_ORDER:
      return action.data;
    case ProcessActionType.UPDATE_PROCESS_ACTIVITY_ORDER_OK:
      return action.data.map((activity) => activity.id);
    case ActivityActionType.GET_ACTIVITY_OK:
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    case ActivityActionType.DELETE_ACTIVITY_OK:
      return state.filter((id) => id !== action.activityId);
    case ActivityActionType.CREATE_ACTIVITY_OK:
      return [...state, action.data.id];
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
